import React from 'react';
import { areButtonsWrapped } from '../utils/are-buttons-wrapped.js';
import { getCardType } from '../utils/get-card-type.js';
import { formatClassName as _formatClassName } from '../../../utils/formatClassName.js';
import { CardActionBox } from '../../CardComponents/card-action-box/component.js';
var LegacyCardActions = function LegacyCardActions(_ref) {
  var cardProps = _ref.cardProps,
    cardEffects = _ref.cardEffects;
  var actionsClass = cardProps.actionsClass,
    buttonConfig = cardProps.buttonConfig,
    _cardProps$buttonPosi = cardProps.buttonPosition,
    buttonPosition = _cardProps$buttonPosi === void 0 ? 'top' : _cardProps$buttonPosi,
    chakra = cardProps.chakra,
    isChildCard = cardProps.isChildCard,
    _cardProps$mediaSize = cardProps.mediaSize,
    mediaSize = _cardProps$mediaSize === void 0 ? 'large' : _cardProps$mediaSize,
    parentLabel = cardProps.parentLabel,
    parentMediaSize = cardProps.parentMediaSize,
    parentWrapped = cardProps.parentWrapped,
    stackedButtons = cardProps.stackedButtons,
    sortableOptions = cardProps.sortableOptions,
    _cardProps$type = cardProps.type,
    type = _cardProps$type === void 0 ? 'wide' : _cardProps$type;
  var _ref2 = sortableOptions || {},
    showDelete = _ref2.showDelete,
    onDelete = _ref2.onDelete;
  var cardWidth = cardEffects.cardWidth,
    hasMedia = cardEffects.hasMedia,
    width = cardEffects.width;
  if (!buttonConfig && !showDelete) {
    return null;
  }
  var cardType = getCardType(width, type);
  var buttonCount = buttonConfig ? buttonConfig.length : undefined;
  var largeMedia = mediaSize === 'large';
  var largeParent = parentMediaSize === 'large';
  var buttonsWrapped = areButtonsWrapped({
    buttonCount: buttonCount,
    cardWidth: cardWidth,
    hasMedia: !!hasMedia,
    isChildCard: isChildCard,
    largeMedia: largeMedia,
    largeParent: largeParent,
    parentLabel: parentLabel,
    parentWrapped: parentWrapped,
    stackedButtons: stackedButtons
  });
  var className = _formatClassName(['card-actions', actionsClass, "card-actions-".concat(cardType), "card-actions-".concat(buttonPosition), {
    'card-actions-wrapped': buttonsWrapped
  }, {
    'actions-stacked': stackedButtons
  }]);

  // Any type until CardActionBox is converted to TS - TODO: proper type once it is migrated
  var buttons = showDelete ? [{
    action: onDelete,
    icon: 'trash',
    style: 'link',
    iconProps: {
      color: 'red'
    },
    className: 'btn-delete-card',
    data: {
      action: 'delete-card'
    },
    'aria-label': 'Delete card'
  }] : buttonConfig;
  return /*#__PURE__*/React.createElement(CardActionBox, {
    buttons: Array.isArray(buttons) ? buttons : [],
    chakra: chakra,
    className: className,
    onClick: function onClick(e) {
      return e.stopPropagation();
    }
  });
};
LegacyCardActions.displayName = "LegacyCardActions";
LegacyCardActions.displayName = 'CardActions';
export { LegacyCardActions };